import React from "react";
import { Mail, QrCode, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Shown after waiver sign (or when waiver already on file) for walk-in check-in.
 * Players show the QR from their email (or account) at the front desk scanner.
 */
const CheckInEmailPrompt = ({
  title = "Waiver on file",
  subtitle,
  guest = false,
  email,
  showAccountLink = true,
}) => (
  <div
    className="min-h-[calc(100vh-72px)] bg-spike-surface flex items-center justify-center px-6 py-12"
    data-testid="checkin-email-prompt"
  >
    <div className="max-w-lg w-full bg-spike-elevated border border-spike-blue/30 p-8 lg:p-10 text-center">
      <div className="w-16 h-16 mx-auto bg-spike-blue/15 border border-spike-blue/40 flex items-center justify-center mb-6">
        {guest ? (
          <Mail className="w-8 h-8 text-spike-blue-light" strokeWidth={1.5} />
        ) : (
          <QrCode className="w-8 h-8 text-spike-blue-light" strokeWidth={1.5} />
        )}
      </div>
      <h1 className="font-orbitron font-black uppercase text-2xl sm:text-3xl text-spike-text tracking-tight">
        {title}
      </h1>
      <p className="mt-4 font-exo text-spike-text-muted text-sm leading-relaxed">
        {subtitle || (
          guest ? (
            <>
              We sent a check-in QR to{" "}
              <span className="text-spike-text font-semibold">{email || "your email"}</span>.
              Show it at the front desk when you arrive. Keep the QR from your email handy.
            </>
          ) : (
            <>
              Your signed waiver PDF and check-in QR are in your email
              {email ? (
                <>
                  {" "}
                  (<span className="text-spike-text">{email}</span>)
                </>
              ) : null}
              . Show the QR at the front desk when you arrive.
            </>
          )
        )}
      </p>
      <ul className="mt-8 text-left max-w-sm mx-auto space-y-3 font-exo text-sm text-spike-text-muted">
        <li className="flex gap-3">
          <CheckCircle2 className="w-4 h-4 text-spike-blue-light shrink-0 mt-0.5" />
          <span>Open the email on your phone and keep the QR ready.</span>
        </li>
        <li className="flex gap-3">
          <CheckCircle2 className="w-4 h-4 text-spike-blue-light shrink-0 mt-0.5" />
          <span>Front desk will scan your QR to check you in.</span>
        </li>
        {!guest && showAccountLink ? (
          <li className="flex gap-3">
            <CheckCircle2 className="w-4 h-4 text-spike-blue-light shrink-0 mt-0.5" />
            <span>
              Lost the email? View or regenerate your QR from{" "}
              <Link to="/account" className="text-spike-blue-light underline">
                My account
              </Link>
              .
            </span>
          </li>
        ) : null}
      </ul>
    </div>
  </div>
);

export default CheckInEmailPrompt;
